//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTCuenta } from '../models/CCTCuenta';
import { store } from './store';

export default class CCTCuentaStore {
    CCTCuentaRegistry = new Map<any, CCTCuenta>();
    

    selectedCCTCuenta: CCTCuenta | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""

    constructor() {
        makeAutoObservable(this)
    }

    get CCTCuentaByCodigo() {
        return Array.from(this.CCTCuentaRegistry.values());
    }

    get groupedCCTCuentas() {
        return this.CCTCuentaRegistry
    }

    loadCCTCuentas = async () => {
        this.loadingInitial = true;
        try {
            const CCTCuentas: CCTCuenta[] = await agent.CCTCuentas.list();
            CCTCuentas.forEach(element => {
                this.setCCTCuenta(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }
    
    loadCCTCuenta = async (idCliente: string) => {
        let CCTCuenta = this.getCCTCuenta(idCliente);
        if (CCTCuenta) {
            this.selectedCCTCuenta = CCTCuenta;
            return CCTCuenta;
        } else {
            this.loadingInitial = true;
            try {
                this.CCTCuentaRegistry.clear()
                const CCTCuentas: CCTCuenta[] =  await agent.CCTCuentas.details(idCliente);
                const saldos:any [] = []
                let contador = 0
                CCTCuentas.forEach(element => {
                    this.setCCTCuenta(element);
                    contador = contador + 1
                    saldos[contador] = element.saldoActual
                })
                this.sumaSaldos(saldos)
                runInAction(() => {
                    this.selectedCCTCuenta = CCTCuenta || this.selectedCCTCuenta;
                })
                this.setLoadingInitial(false);
                return CCTCuenta;
            } catch (error) {
                this.setLoadingInitial(false);
                toast.error("No tienes cuenta corriente")
            }
        }
    }

    sumaSaldos = (saldo:any []) => {
        const nf = new Intl.NumberFormat("en-IN");
       var saldoTotal = saldo.reduce(function(a, b){ return a + b; })
       this.saldo_actual_total = nf.format(saldoTotal)
        if((saldoTotal % 1) == 0){
            this.saldo_actual_total = this.saldo_actual_total + ".00"
        }
    }

    private setCCTCuenta = (data: CCTCuenta) => {
        this.CCTCuentaRegistry.set(data.cuenta, data);
    }

    private getCCTCuenta = (idCliente: any) => {
        return this.CCTCuentaRegistry.get(idCliente);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    // createCCTCuenta = async (CCTCuenta: CCTCuentaFormValues) => {
    //     try {
    //         await agent.CCTCuentas.create(CCTCuenta);
    //         runInAction(() => {
    //             this.selectedCCTCuenta = CCTCuenta;
    //             this.loading = false;
    //         })
    //     } catch (error) {
    //         runInAction(() => {
    //             this.loading = false;
    //         })
    //     }
    // }

    // updateCCTCuenta = async (CCTCuenta: CCTCuentaFormValues) => {
    //     try {
    //         await agent.CCTCuentas.update(CCTCuenta);
    //         runInAction(() => {
    //             if (CCTCuenta.idCliente) {
    //                 let updateCCTCuenta = {...this.getCCTCuenta(CCTCuenta.idCliente), ...CCTCuenta}
    //                 this.CCTCuentaRegistry.set(CCTCuenta.idCliente, updateCCTCuenta as CCTCuenta);
    //                 this.selectedCCTCuenta = updateCCTCuenta as CCTCuenta
    //                 this.loading = false;
    //             }
                   
    //         } )
    //     } catch (error) {
    //     }
    // }

    // deleteCCTCuenta = async (idCliente: string) => {
    //     this.loading = true;
    //     try {
    //         await agent.CCTCuentas.delete(idCliente);
    //         runInAction(() => {
    //             this.CCTCuentaRegistry.delete(idCliente);
    //             this.loading = false;
    //         })
    //     } catch (error) {
    //         runInAction(() => {
    //             this.loading = false;
    //         })
    //     }
    // }
}